import MockAdapter from 'axios-mock-adapter';
import { AxiosInstance, AxiosRequestConfig } from 'axios';

import userIdentityApiRoutes from 'src/modules/UserIdentity/constants/apiRoutes';
import documentApiRoutes from 'src/modules/DocumentsPrivate/constants/apiRoutes';
import { AgreementStatusEnum } from 'src/modules/DocumentsPrivate/constants/document';
import { NationalNodeResponseStatus } from 'src/modules/UserIdentity/constants/errors';

export const mockApi = (instance: AxiosInstance) => {
  const mock = new MockAdapter(instance, { delayResponse: 500 });

  mock.onGet(documentApiRoutes.health).reply(200, {
    status: 'ok'
  });

  mock.onGet(documentApiRoutes.deviceIp).reply(200, {
    deviceIP: '10.0.114.65'
  });

  mock
    .onGet(
      new RegExp(
        `${documentApiRoutes.privateDocumentList.replace(
          '{uuid}',
          'user-uuid'
        )}*`
      )
    )
    .reply(200, {
      count: 8,
      indexEntriesList: [
        {
          encryptedDocumentData:
            'ZBnrue2rADnz1f7V57Zo695ewlUeqYHWihI2mh0Ox5qpF9TtNrNUWil3lm1h+IapbxlQdU6KfFEmeueQAiYPo4kojVCvRMhqGE3frpHWcRfnaj0FVwOATif+4KS80fReshH44voPt/TzUEAf5mJVhI9B1KeqWzMC5QUZ3Zzh+OVWx8Wb5+AMmfncEy0qsd1qmLPTJCy0SARegYd2lKhVJlHAbYctb+H2',
          creationDate: '2023-03-31T16:06:04Z',
          retentionDate: '2024-03-31T14:46:15Z',
          publisherId: '6VySMN3bWJ6vEAbxDJsrBC3E',
          publicationMode: 'NEW',
          encryptedCek:
            'MIGvAgEBMA0ECNcCYU21ZHH2AgEBBIGaBFo22U1tWvwBlGUBLsx1Q8DGVorlkn3pOCVrtDZavfJQDcd1vileI5eIhyseN0PrqwvKmRsl/4bBxayT2hHHCGO5/j0zaaf8kbAjwOGCak4Kjbq1nJoROS9qmOCMgZPkDB43tyzGuJKtBiWkRmbQZwaTnnXglcRbhIut8fZIVQpB4tj5qkq78m1IRensR/c71sAXEHIvAgNZxQ==',
          documentHash:
            'Xd4YKN73a8uBUlj02P+5cWciWGAZXC7XwhSHf3kRLbDRayLj4Dzc6fjpDy0/6GzqcAzm0DIhFbmiZGlUOZp0ig==',
          extension: 'PDF',
          decryptedData: {
            blockchainAddress: 'test-chain-address',
            title: 'Test-tile',
            categoryHash: 'test-hash'
          }
        },
        {
          signingStatus: 'WAITING_FOR_RECEIVER',
          encryptedDocumentData:
            'ZBnrue2rADnz1f7V57Zo695ewlUeqYHWihI2mh0Ox5qpF9TtNrNUWil3lm1h+IapbxlQdU6KfFEmeueQAiYPo4kojVCvRMhqGE3frpHWcRfnaj0FVwOATif+4KS80fReshH44voPt/TzUEAf5mJVhI9B1KeqWzMC5QUZ3Zzh+OVWx8Wb5+AMmfncEy0qsd1qmLPTJCy0SARegYd2lKhVJlHAbYctb+H2',
          creationDate: '2023-03-31T16:06:04Z',
          retentionDate: '2024-03-31T14:46:15Z',
          publisherId: '6VySMN3bWJ6vEAbxDJsrBC3E',
          publicationMode: 'NEW',
          encryptedCek:
            'MIGvAgEBMA0ECNcCYU21ZHH2AgEBBIGaBFo22U1tWvwBlGUBLsx1Q8DGVorlkn3pOCVrtDZavfJQDcd1vileI5eIhyseN0PrqwvKmRsl/4bBxayT2hHHCGO5/j0zaaf8kbAjwOGCak4Kjbq1nJoROS9qmOCMgZPkDB43tyzGuJKtBiWkRmbQZwaTnnXglcRbhIut8fZIVQpB4tj5qkq78m1IRensR/c71sAXEHIvAgNZxQ==',
          documentHash:
            'Xd4YKN73a8uBUlj02P+5cWciWGAZXC7XwhSHf3kRLbDRayLj4Dzc6fjpDy0/6GzqcAzm0DIhFbmiZGlUOZp0ig==',
          extension: 'PDF',
          decryptedData: {
            blockchainAddress: 'test-agreement-address',
            title: 'Test-pending-agreement',
            categoryHash: 'test-hash'
          }
        },
        {
          signingStatus: 'REJECTED',
          encryptedDocumentData:
            'ZBnrue2rADnz1f7V57Zo695ewlUeqYHWihI2mh0Ox5qpF9TtNrNUWil3lm1h+IapbxlQdU6KfFEmeueQAiYPo4kojVCvRMhqGE3frpHWcRfnaj0FVwOATif+4KS80fReshH44voPt/TzUEAf5mJVhI9B1KeqWzMC5QUZ3Zzh+OVWx8Wb5+AMmfncEy0qsd1qmLPTJCy0SARegYd2lKhVJlHAbYctb+H2',
          creationDate: '2023-03-31T16:06:04Z',
          retentionDate: '2024-03-31T14:46:15Z',
          publisherId: '6VySMN3bWJ6vEAbxDJsrBC3E',
          publicationMode: 'NEW',
          encryptedCek:
            'MIGvAgEBMA0ECNcCYU21ZHH2AgEBBIGaBFo22U1tWvwBlGUBLsx1Q8DGVorlkn3pOCVrtDZavfJQDcd1vileI5eIhyseN0PrqwvKmRsl/4bBxayT2hHHCGO5/j0zaaf8kbAjwOGCak4Kjbq1nJoROS9qmOCMgZPkDB43tyzGuJKtBiWkRmbQZwaTnnXglcRbhIut8fZIVQpB4tj5qkq78m1IRensR/c71sAXEHIvAgNZxQ==',
          documentHash:
            'Xd4YKN73a8uBUlj02P+5cWciWGAZXC7XwhSHf3kRLbDRayLj4Dzc6fjpDy0/6GzqcAzm0DIhFbmiZGlUOZp0ig==',
          extension: 'PDF',
          decryptedData: {
            blockchainAddress: 'test-rejected-agreement-address',
            title: 'Test-rejected-agreement',
            categoryHash: 'test-hash'
          }
        },
        {
          signingStatus: 'ACCEPTED_WAITING_FOR_PUBLISHING',
          encryptedDocumentData:
            'ZBnrue2rADnz1f7V57Zo695ewlUeqYHWihI2mh0Ox5qpF9TtNrNUWil3lm1h+IapbxlQdU6KfFEmeueQAiYPo4kojVCvRMhqGE3frpHWcRfnaj0FVwOATif+4KS80fReshH44voPt/TzUEAf5mJVhI9B1KeqWzMC5QUZ3Zzh+OVWx8Wb5+AMmfncEy0qsd1qmLPTJCy0SARegYd2lKhVJlHAbYctb+H2',
          creationDate: '2023-03-31T16:06:04Z',
          retentionDate: '2024-03-31T14:46:15Z',
          publisherId: '6VySMN3bWJ6vEAbxDJsrBC3E',
          publicationMode: 'NEW',
          encryptedCek:
            'MIGvAgEBMA0ECNcCYU21ZHH2AgEBBIGaBFo22U1tWvwBlGUBLsx1Q8DGVorlkn3pOCVrtDZavfJQDcd1vileI5eIhyseN0PrqwvKmRsl/4bBxayT2hHHCGO5/j0zaaf8kbAjwOGCak4Kjbq1nJoROS9qmOCMgZPkDB43tyzGuJKtBiWkRmbQZwaTnnXglcRbhIut8fZIVQpB4tj5qkq78m1IRensR/c71sAXEHIvAgNZxQ==',
          documentHash:
            'Xd4YKN73a8uBUlj02P+5cWciWGAZXC7XwhSHf3kRLbDRayLj4Dzc6fjpDy0/6GzqcAzm0DIhFbmiZGlUOZp0ig==',
          extension: 'PDF',
          decryptedData: {
            blockchainAddress: 'test-accepted-waiting-for-publishing',
            title: 'test-accepted-waiting-for-publishing',
            categoryHash: 'test-hash'
          }
        },
        {
          signingStatus: 'REJECTED_WAITING_FOR_PUBLISHING',
          encryptedDocumentData:
            'ZBnrue2rADnz1f7V57Zo695ewlUeqYHWihI2mh0Ox5qpF9TtNrNUWil3lm1h+IapbxlQdU6KfFEmeueQAiYPo4kojVCvRMhqGE3frpHWcRfnaj0FVwOATif+4KS80fReshH44voPt/TzUEAf5mJVhI9B1KeqWzMC5QUZ3Zzh+OVWx8Wb5+AMmfncEy0qsd1qmLPTJCy0SARegYd2lKhVJlHAbYctb+H2',
          creationDate: '2023-03-31T16:06:04Z',
          retentionDate: '2024-03-31T14:46:15Z',
          publisherId: '6VySMN3bWJ6vEAbxDJsrBC3E',
          publicationMode: 'NEW',
          encryptedCek:
            'MIGvAgEBMA0ECNcCYU21ZHH2AgEBBIGaBFo22U1tWvwBlGUBLsx1Q8DGVorlkn3pOCVrtDZavfJQDcd1vileI5eIhyseN0PrqwvKmRsl/4bBxayT2hHHCGO5/j0zaaf8kbAjwOGCak4Kjbq1nJoROS9qmOCMgZPkDB43tyzGuJKtBiWkRmbQZwaTnnXglcRbhIut8fZIVQpB4tj5qkq78m1IRensR/c71sAXEHIvAgNZxQ==',
          documentHash:
            'Xd4YKN73a8uBUlj02P+5cWciWGAZXC7XwhSHf3kRLbDRayLj4Dzc6fjpDy0/6GzqcAzm0DIhFbmiZGlUOZp0ig==',
          extension: 'PDF',
          decryptedData: {
            blockchainAddress: 'test-rejected-waiting-for-publishing',
            title: 'Test-test-rejected-waiting-for-publishing',
            categoryHash: 'test-hash'
          }
        },
        {
          signingStatus: 'ACCEPTED',
          encryptedDocumentData:
            'ZBnrue2rADnz1f7V57Zo695ewlUeqYHWihI2mh0Ox5qpF9TtNrNUWil3lm1h+IapbxlQdU6KfFEmeueQAiYPo4kojVCvRMhqGE3frpHWcRfnaj0FVwOATif+4KS80fReshH44voPt/TzUEAf5mJVhI9B1KeqWzMC5QUZ3Zzh+OVWx8Wb5+AMmfncEy0qsd1qmLPTJCy0SARegYd2lKhVJlHAbYctb+H2',
          creationDate: '2023-03-31T16:06:04Z',
          retentionDate: '2024-03-31T14:46:15Z',
          publisherId: '6VySMN3bWJ6vEAbxDJsrBC3E',
          publicationMode: 'NEW',
          encryptedCek:
            'MIGvAgEBMA0ECNcCYU21ZHH2AgEBBIGaBFo22U1tWvwBlGUBLsx1Q8DGVorlkn3pOCVrtDZavfJQDcd1vileI5eIhyseN0PrqwvKmRsl/4bBxayT2hHHCGO5/j0zaaf8kbAjwOGCak4Kjbq1nJoROS9qmOCMgZPkDB43tyzGuJKtBiWkRmbQZwaTnnXglcRbhIut8fZIVQpB4tj5qkq78m1IRensR/c71sAXEHIvAgNZxQ==',
          documentHash:
            'Xd4YKN73a8uBUlj02P+5cWciWGAZXC7XwhSHf3kRLbDRayLj4Dzc6fjpDy0/6GzqcAzm0DIhFbmiZGlUOZp0ig==',
          extension: 'PDF',
          decryptedData: {
            blockchainAddress: 'test-accepted-agreement-address',
            title: 'Test-accepted-agreement',
            categoryHash: 'test-hash'
          }
        },
        {
          signingStatus: 'REJECTED',
          encryptedDocumentData:
            'ZBnrue2rADnz1f7V57Zo695ewlUeqYHWihI2mh0Ox5qpF9TtNrNUWil3lm1h+IapbxlQdU6KfFEmeueQAiYPo4kojVCvRMhqGE3frpHWcRfnaj0FVwOATif+4KS80fReshH44voPt/TzUEAf5mJVhI9B1KeqWzMC5QUZ3Zzh+OVWx8Wb5+AMmfncEy0qsd1qmLPTJCy0SARegYd2lKhVJlHAbYctb+H2',
          creationDate: '2023-03-31T16:06:04Z',
          retentionDate: '2024-03-31T14:46:15Z',
          publisherId: '6VySMN3bWJ6vEAbxDJsrBC3E',
          publicationMode: 'NEW',
          encryptedCek:
            'MIGvAgEBMA0ECNcCYU21ZHH2AgEBBIGaBFo22U1tWvwBlGUBLsx1Q8DGVorlkn3pOCVrtDZavfJQDcd1vileI5eIhyseN0PrqwvKmRsl/4bBxayT2hHHCGO5/j0zaaf8kbAjwOGCak4Kjbq1nJoROS9qmOCMgZPkDB43tyzGuJKtBiWkRmbQZwaTnnXglcRbhIut8fZIVQpB4tj5qkq78m1IRensR/c71sAXEHIvAgNZxQ==',
          documentHash:
            'Xd4YKN73a8uBUlj02P+5cWciWGAZXC7XwhSHf3kRLbDRayLj4Dzc6fjpDy0/6GzqcAzm0DIhFbmiZGlUOZp0ig==',
          extension: 'PDF',
          decryptedData: {
            blockchainAddress: 'test-rejected-agreement-address',
            title: 'Test-rejected-agreement',
            categoryHash: 'test-hash'
          }
        },
        {
          signingStatus: 'ACCEPTED_WAITING_FOR_PUBLISHING',
          encryptedDocumentData:
            'ZBnrue2rADnz1f7V57Zo695ewlUeqYHWihI2mh0Ox5qpF9TtNrNUWil3lm1h+IapbxlQdU6KfFEmeueQAiYPo4kojVCvRMhqGE3frpHWcRfnaj0FVwOATif+4KS80fReshH44voPt/TzUEAf5mJVhI9B1KeqWzMC5QUZ3Zzh+OVWx8Wb5+AMmfncEy0qsd1qmLPTJCy0SARegYd2lKhVJlHAbYctb+H2',
          creationDate: '2023-03-31T16:06:04Z',
          retentionDate: '2024-03-31T14:46:15Z',
          publisherId: '6VySMN3bWJ6vEAbxDJsrBC3E',
          publicationMode: 'NEW',
          encryptedCek:
            'MIGvAgEBMA0ECNcCYU21ZHH2AgEBBIGaBFo22U1tWvwBlGUBLsx1Q8DGVorlkn3pOCVrtDZavfJQDcd1vileI5eIhyseN0PrqwvKmRsl/4bBxayT2hHHCGO5/j0zaaf8kbAjwOGCak4Kjbq1nJoROS9qmOCMgZPkDB43tyzGuJKtBiWkRmbQZwaTnnXglcRbhIut8fZIVQpB4tj5qkq78m1IRensR/c71sAXEHIvAgNZxQ==',
          documentHash:
            'Xd4YKN73a8uBUlj02P+5cWciWGAZXC7XwhSHf3kRLbDRayLj4Dzc6fjpDy0/6GzqcAzm0DIhFbmiZGlUOZp0ig==',
          extension: 'PDF',
          decryptedData: {
            blockchainAddress: 'test-accepted-waiting-for-publishing',
            title: 'test-accepted-waiting-for-publishing',
            categoryHash: 'test-hash'
          }
        },
        {
          signingStatus: 'REJECTED_WAITING_FOR_PUBLISHING',
          encryptedDocumentData:
            'ZBnrue2rADnz1f7V57Zo695ewlUeqYHWihI2mh0Ox5qpF9TtNrNUWil3lm1h+IapbxlQdU6KfFEmeueQAiYPo4kojVCvRMhqGE3frpHWcRfnaj0FVwOATif+4KS80fReshH44voPt/TzUEAf5mJVhI9B1KeqWzMC5QUZ3Zzh+OVWx8Wb5+AMmfncEy0qsd1qmLPTJCy0SARegYd2lKhVJlHAbYctb+H2',
          creationDate: '2023-03-31T16:06:04Z',
          retentionDate: '2024-03-31T14:46:15Z',
          publisherId: '6VySMN3bWJ6vEAbxDJsrBC3E',
          publicationMode: 'NEW',
          encryptedCek:
            'MIGvAgEBMA0ECNcCYU21ZHH2AgEBBIGaBFo22U1tWvwBlGUBLsx1Q8DGVorlkn3pOCVrtDZavfJQDcd1vileI5eIhyseN0PrqwvKmRsl/4bBxayT2hHHCGO5/j0zaaf8kbAjwOGCak4Kjbq1nJoROS9qmOCMgZPkDB43tyzGuJKtBiWkRmbQZwaTnnXglcRbhIut8fZIVQpB4tj5qkq78m1IRensR/c71sAXEHIvAgNZxQ==',
          documentHash:
            'Xd4YKN73a8uBUlj02P+5cWciWGAZXC7XwhSHf3kRLbDRayLj4Dzc6fjpDy0/6GzqcAzm0DIhFbmiZGlUOZp0ig==',
          extension: 'PDF',
          decryptedData: {
            blockchainAddress: 'test-rejected-waiting-for-publishing',
            title: 'Test-test-rejected-waiting-for-publishing',
            categoryHash: 'test-hash'
          }
        },
        {
          signingStatus: 'ACCEPTED',
          encryptedDocumentData:
            'ZBnrue2rADnz1f7V57Zo695ewlUeqYHWihI2mh0Ox5qpF9TtNrNUWil3lm1h+IapbxlQdU6KfFEmeueQAiYPo4kojVCvRMhqGE3frpHWcRfnaj0FVwOATif+4KS80fReshH44voPt/TzUEAf5mJVhI9B1KeqWzMC5QUZ3Zzh+OVWx8Wb5+AMmfncEy0qsd1qmLPTJCy0SARegYd2lKhVJlHAbYctb+H2',
          creationDate: '2023-03-31T16:06:04Z',
          retentionDate: '2024-03-31T14:46:15Z',
          publisherId: '6VySMN3bWJ6vEAbxDJsrBC3E',
          publicationMode: 'NEW',
          encryptedCek:
            'MIGvAgEBMA0ECNcCYU21ZHH2AgEBBIGaBFo22U1tWvwBlGUBLsx1Q8DGVorlkn3pOCVrtDZavfJQDcd1vileI5eIhyseN0PrqwvKmRsl/4bBxayT2hHHCGO5/j0zaaf8kbAjwOGCak4Kjbq1nJoROS9qmOCMgZPkDB43tyzGuJKtBiWkRmbQZwaTnnXglcRbhIut8fZIVQpB4tj5qkq78m1IRensR/c71sAXEHIvAgNZxQ==',
          documentHash:
            'Xd4YKN73a8uBUlj02P+5cWciWGAZXC7XwhSHf3kRLbDRayLj4Dzc6fjpDy0/6GzqcAzm0DIhFbmiZGlUOZp0ig==',
          extension: 'PDF',
          decryptedData: {
            blockchainAddress: 'test-accepted-agreement-address',
            title: 'Test-accepted-agreement',
            categoryHash: 'test-hash'
          }
        }
      ]
    });

  mock
    .onGet(
      new RegExp(
        documentApiRoutes.privateDocumentCatalog.replace(
          '{blockchainAddress}',
          '[a-zA-Z-0-9]+'
        )
      )
    )
    .reply((config: AxiosRequestConfig) => {
      if (config.url?.includes('test-rejected-waiting-for-publishing')) {
        return [
          200,
          {
            documentInfo: 'test',
            encryptedSensitiveContent: 'test',
            encryptedCekList: [],
            signingStatus: 'REJECTED_WAITING_FOR_PUBLISHING'
          }
        ];
      }
      if (config.url?.includes('test-accepted-waiting-for-publishing')) {
        return [
          200,
          {
            documentInfo: 'test',
            encryptedSensitiveContent: 'test',
            encryptedCekList: [],
            signingStatus: 'ACCEPT_WAITING_FOR_PUBLISHING'
          }
        ];
      }
      if (config.url?.includes('test-rejected-agreement-address')) {
        return [
          200,
          {
            documentInfo: 'test',
            encryptedSensitiveContent: 'test',
            encryptedCekList: [],
            signingStatus: 'REJECTED'
          }
        ];
      }
      if (config.url?.includes('test-accepted-agreement-address')) {
        return [
          200,
          {
            documentInfo: 'test-accepted',
            encryptedSensitiveContent: 'test',
            encryptedCekList: [],
            signingStatus: 'ACCEPTED'
          }
        ];
      }
      return [
        200,
        {
          documentInfo: 'test',
          encryptedSensitiveContent: 'test',
          encryptedCekList: []
        }
      ];
    });

  mock
    .onGet(
      new RegExp(
        documentApiRoutes.privateDocumentHistory.replace(
          '{blockchainAddress}',
          '[a-zA-Z-0-9]+'
        )
      )
    )
    .reply((config: AxiosRequestConfig) => {
      if (config.url?.includes('test-rejected-waiting-for-publishing')) {
        return [
          200,
          {
            relatedDocuments: [
              {
                blockchainAddress: 'test-NEW',
                publicationDate: '2023-05-17T09:02:08.000Z',
                publicationMode: 'NEW',
                signingStatus: 'REJECTED_WAITING_FOR_PUBLISHING'
              }
            ]
          }
        ];
      }

      if (config.url?.includes('test-accepted-agreement-address')) {
        return [
          200,
          {
            relatedDocuments: [
              {
                blockchainAddress: 'test-NEW',
                publicationDate: '2023-05-17T09:02:08.000Z',
                publicationMode: 'NEW',
                signingStatus: 'ACCEPTED_DEPRECATED'
              },
              {
                blockchainAddress: 'test-UPDATED',
                publicationDate: '2023-05-20T11:02:08.000Z',
                publicationMode: 'UPDATED',
                signingStatus: 'ACCEPTED'
              }
            ]
          }
        ];
      }

      if (config.url?.includes('test-accepted-agreement-address')) {
        return [
          200,
          {
            relatedDocuments: [
              {
                blockchainAddress: 'test-NEW',
                publicationDate: '2023-05-17T09:02:08.000Z',
                publicationMode: 'NEW',
                signingStatus: 'ACCEPTED_DEPRECATED'
              },
              {
                blockchainAddress: 'test-UPDATED',
                publicationDate: '2023-05-20T11:02:08.000Z',
                publicationMode: 'UPDATED',
                signingStatus: 'ACCEPTED'
              }
            ]
          }
        ];
      }

      if (config.url?.includes('test-rejected-agreement-address')) {
        return [
          200,
          {
            relatedDocuments: [
              {
                blockchainAddress: 'test-NEW',
                publicationDate: '2023-05-17T09:02:08.000Z',
                publicationMode: 'NEW',
                signingStatus: 'REJECTED_DEPRECATED'
              },
              {
                blockchainAddress: 'test-UPDATED',
                publicationDate: '2023-05-20T11:02:08.000Z',
                publicationMode: 'UPDATED',
                signingStatus: 'REJECTED'
              }
            ]
          }
        ];
      }

      if (config.url?.includes('test-accepted-waiting-for-publishing')) {
        return [
          200,
          {
            relatedDocuments: [
              {
                blockchainAddress: 'test-NEW',
                publicationDate: '2023-05-17T09:02:08.000Z',
                publicationMode: 'NEW',
                signingStatus: 'ACCEPTED_WAITING_FOR_PUBLISHING'
              }
            ]
          }
        ];
      }

      return [
        200,
        {
          relatedDocuments: [
            {
              blockchainAddress: 'test-NEW',
              publicationDate: '2023-05-17T09:02:08.000Z',
              publicationMode: 'NEW'
            },
            {
              blockchainAddress: 'test-CORRECTED',
              publicationDate: '2023-05-18T10:02:08.000Z',
              publicationMode: 'CORRECTED'
            },
            {
              blockchainAddress: 'test-ERRATA',
              publicationDate: '2023-05-19T13:02:08.000Z',
              publicationMode: 'ERRATA'
            },
            {
              blockchainAddress: 'test-UPDATED',
              publicationDate: '2023-05-20T11:02:08.000Z',
              publicationMode: 'INCIDENT'
            },
            {
              blockchainAddress: 'test-ACCEPTED-DOCUMENT',
              publicationDate: '2023-05-21T11:02:08.000Z',
              publicationMode: 'UPDATED',
              signingStatus: 'ACCEPTED'
            }
          ]
        }
      ];
    });

  mock
    .onPost(
      new RegExp(
        documentApiRoutes.verifyDocument.replace(
          '{blockchainAddress}',
          '[a-zA-Z-0-9\\-]+'
        )
      )
    )
    .reply(200, {
      documentBlockchainAddress: 'test-3xVodkzTBZzvNa4test-hash-base58C7E',
      publicationDate: new Date().toString(),
      publisherId: 'test-address',
      base58: 'test-hash-base58',
      base64: 'test-hash-base64',
      hex: 'test-hash-hex'
    });
  mock.onGet(documentApiRoutes.publishers).reply(200, {
    publishers: [
      {
        publisherId: 'test-address',
        name: 'Billon-mock',
        logo: 'logoId'
      }
    ]
  });

  mock.onGet(documentApiRoutes.categories).reply(200, {
    categoriesList: [
      {
        active: true,
        name: 'test-category',
        hash: 'test-hash',
        parentPath: 'parent-match',
        publisherId: 'publusher'
      }
    ]
  });

  mock.onPost(userIdentityApiRoutes.verifyResendCode).reply(200, {
    ok: true
  });

  mock.onPost(userIdentityApiRoutes.fullIdentityUserUuid).reply(200, {
    uuid: 'user-uuid',
    firstName: 'Andrzej',
    lastName: 'Oligamy',
    ok: true
  });

  mock.onPost(userIdentityApiRoutes.fullIdentityLoadUserKeys).reply(200, {
    status: 'OK',
    uuid: 'user-uuid',
    semiFullIdentityKeysList: [
      {
        publisherCif: null,
        publisherId: null,
        keyStatusFlag: 'READY-TO-USE',
        encryptedPassword: 'U7jzrDGDs6kvr7A/dNOuOf6dbE2R0NPHBYweo0yYlnk=',
        encryptedPrivateKeys:
          '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',
        encryptedKek:
          'MDcCAQEEEMq0pbc7+4qK1atgXTRKy6UEIKQLL/l9+IvfClCFIeN6JIUvo/QfT3xhdpgiu8ZBCVFQ'
      },
      {
        publisherCif: '05212188436',
        publisherId: '6VySMMwabodwBiwwWSzW96jh',
        keyStatusFlag: 'READY-TO-USE',
        encryptedPassword:
          'MIGWAgEBMA0ECAxnJGzO80QWAgEBBIGBBGoIY3gZXDxBpNyltZmKYLyQ0gpezQcC2OT8lpItF7mocz5WxjQtSr6bPx1HDRM1BTajo9UF6v3+3FD5q7iyk3F6WJD2NFEkbn+L/3AQLIxwY4XyT2mg1L38/PxqSQuLLNXqc/6T1NRVRfqZD5duw8J3EuooZqoDMQWMBSZs7BCy',
        encryptedPrivateKeys:
          'wILwOTCZU1ZjRZ7+0f43mWkqOkre0j+QofXjbO9koGnq6ds5OQes2gQ29wYPmFv1FwGePzaKBqK4jPYvXDKVC3YGQ4++6XuaFC7cIrB6kqPXVMpIjWGGtEGtzSJ97JSzHihXPuRCfPDSNOkJg35qX/iLjqzvJl2uMYeoWENFKuqLC8Topw4zUlJj9dP3GXgSR8XoILt1K3GAs7RoAano1CR4e5I3pdI48cB2LtssEshij1EVXVWsGquiUVILxediHgrVPyja4oVZT9lij+IYYW0e3YgcwEVdlT8gt08LrXLp4erIngj9aDHVdjf5ym3/wz8z5g7m6zOYf5YRx8tULMp725Kkmy15phqDzd52CfPXw90FHP3zcEWK3lEizjexkUj3iDwKcwVmPzOVrSbwJO/gGciyM9yb18MCwqd6gTVp5jqZkUKLpOguf2CXcMv9/jbJrCc08QqXraipFjqH/uCmwojSeJJWQIDT4E0CKosdwlaFEzx9fkgE3ZfwM7ouNL0KCZn1qNFSj2KM/pLwtLolAVKv3GOg1Xaz6ob8y5EvPlUHr+/hU8ZgWFIg4p6d5FI+pNJH89JCc3/Qe4FO053zK9HJ1Sz5XmV808p6PQIyfKEGzJC5orM7a3wh5ARHUyYzV96JkL7aUrESnQp0dw9Fhr9WueJxepcmhTOX5lULvbxrJM3Wam4nD0+8Qf1jUTdFwf4jHTDmFKP5jcikPyuuae/oWIlIYww7SOCL2qL8p0D4KJ/2ExfocaOgYpo1pxEdsf9ZfBllOQ9Dj/IQ4mnnYP6PEZiXac8GeJcN2BRKzA2B3/e9R4+cAR2ibi6eNkXi55Bwq+nI95agyhAG+ILM21u482TzmC69sLcIv8nnBWYD1/K4iCqcPrXu+q2iGsvqMArzPEO1KFOhMBNMwXMNOWDAgDxPPx4zAM9HdOwqy6Z5JfANc5dpdT+JumPzjKPhDllgHCD2h1YHpLLwzFRdThKffYY0RJKLHIDZ8ZanHPK7DfI0Wq3O5jFLslpaZcvhHr+5quzFS2C13hIEjww8MLFTDz6D23LMy8AwbDDZWEE8LGsXlrUNbaJDML15t+uUB3MBSbu75oqlzti5Pt/8ZBC4eLxfyXsJMO8x6/qC4R+PA+/usGYaJm3K4CMjICbFxy31E3e50OXom+SkQuRA81PqQNG3BsBc6QhwcX5iYPqdCp3dZa3f2JRHXjt6FbH/qkaJhd7zHsI5uuDyj7nISaB+vbTml/m7zZh78DGJGcESTgZoc+/Uhchncj6F19CpUpuo6jhOyvMEVTU0ATMrKkvp6kJpT2CGGQELlnoUK7IeiyccLnqBkFEvcKt9ToXenngLhLF2hASyvzPUKAUrcWAXlmYjzd4MOc2H6ekQKoDNpXjRTfPQQ42mKNSCbqGJ0X17pOPpSzvzdZYKW/S6Mv/gZ1HZYweBQeJzj1NTT9EvHSfq1Rz7BEA7ect/bounMyP/zfPrM1MPf3tktpfuU+S41iFsMJc6bZtAzT/ESfcu/C3bsuORJYp/aWf+eiWFEuw231PukRis6PJDYEsfBi1nuYz1qolBXm3E9umDB2SWvdG3UKn0G8eUWKqnLNnyllmo1X1hzX6W7EUI3u8/GXrIPGxn7UYSa/j8LidaRCICBXU39BGVN204y51F8cQ7/yrCo893mJ5TNcAVvUVQ58aizNnWwJkh9JfxFuUkIxHI8jedy0BtgbU76r8Q1GeYvUCgofZY4aW9yXyNShVssmJUU4N6wBb2Brsb',
        encryptedKek:
          'MIGvAgEBMA0ECAxnJGzO80QWAgEBBIGaBCqlMTomBBiml4DUP5eFTsAnpeAyNyrRMUobtMv9WVnhhWBh1Aaxn3HmkuVuqqyLhKUtadrATun+q4scYFaKGDWe0wyJbpr1sLk2cy1raZrkG+ToLcm+WStBccZpkNlptpG8eygLcb9XGMl6FJ2ZDx5Ii98HKbiWmzFJLVsxu6Ct6fXHtqf4papFAIpp3w//7xS8UsfvOkvf/Q=='
      }
    ]
  });

  mock
    .onGet(userIdentityApiRoutes.nationalNodeLogin)
    .reply((config: AxiosRequestConfig) => {
      if (config.params?.sessionId) {
        return [
          200,
          {
            status: NationalNodeResponseStatus.SUCCESS,
            sessionId: '723982fa-49b8-4af6-a879-ac97d34a0c95',
            request: `<!DOCTYPE html><HTML><BODY Onload="document.forms[0].submit()"><FORM METHOD="GET" ACTION=${window.location.origin}/user-identity/national-node/success><INPUT TYPE="HIDDEN" NAME="sessionId" VALUE="723982fa-49b8-4af6-a879-ac97d34a0c95"/><INPUT TYPE="HIDDEN" NAME="SAMLart" VALUE="AAQAADi/bFBGD/IrgCvmOU6qsBQqyyFULq6uK7Jve/ga6vIwPh6we0gPyR4"/></FORM></BODY></HTML>\n`
          }
        ];
      }
    });

  mock
    .onPost(userIdentityApiRoutes.nationalNodeResolve)
    .reply((config: AxiosRequestConfig) => {
      if (config.params?.sessionId && config.params?.encryptedData) {
        return [
          200,
          {
            status: NationalNodeResponseStatus.SUCCESS,
            sessionId: '723982fa-49b8-4af6-a879-ac97d34a0c95',
            identityResponse: {
              currentFamilyName: 'Jan',
              currentGivenName: 'Kowalski',
              dateOfBirth: '1996-11-04',
              personIdentifier: '96110478479',
              attrib:
                '[CURRENT_FAMILY_NAME, CURRENT_GIVEN_NAME, DATE_OF_BIRTH, PERSON_IDENTIFIER]'
            }
          }
        ];
      }
    });

  mock.onPut(userIdentityApiRoutes.verifyFullIdentity).reply(200, {
    processId: 'processId'
  });

  mock.onPut(userIdentityApiRoutes.verifySecretCode).reply(200, {
    processId: 'processId'
  });

  mock.onPost(userIdentityApiRoutes.addFullIdentityStep1).reply(200, {
    processId: 'processId'
  });

  mock.onGet(userIdentityApiRoutes.maintenanceSelfTest).reply(200, {
    service: {
      payload: [
        {
          name: 'KYCIdentityManagementService',
          id: 'test'
        }
      ]
    }
  });

  mock.onGet(userIdentityApiRoutes.maintenanceSettings).reply(200, {
    parameters: {
      CONFIRMATION_CODE_MAX_ATTEMPTS: '5',
      VERIFICATION_CODE_EXPIRATION_TIME: '5',
      CONFIRMATION_CODE_EXPIRATION_TIME: '5',
      VERIFICATION_CODE_MAX_ATTEMPTS: '5',
      LOGIN_TWO_FACTOR_AUTHORIZATION: process.env.REACT_APP_2FA || 'false'
    }
  });

  mock.onPost(userIdentityApiRoutes.addFullIdentityStep2).reply(200, {
    processId: 'processId'
  });

  mock.onPost(userIdentityApiRoutes.fullIdentitySaveKeys).reply(200, {
    processId: 'processId'
  });

  mock
    .onGet(
      userIdentityApiRoutes.fullIdentityStep1Status.replace(
        '{processId}',
        'processId'
      )
    )
    .reply(200, {
      status: 'ADD_FULL_ID_STEP1_FINISHED'
    });

  mock
    .onGet(
      userIdentityApiRoutes.fullIdentityStep2Status.replace(
        '{processId}',
        'processId'
      )
    )
    .reply(200, {
      status: 'ADD_FULL_ID_STEP2_FINISHED',
      uuid: 'user-uuid'
    });

  mock
    .onGet(
      userIdentityApiRoutes.fullIdentitySaveKeysStatus.replace(
        '{processId}',
        'processId'
      )
    )
    .reply(200, {
      uuid: 'user-uuid',
      status: 'SAVE_KEYS_FINISHED'
    });
  mock
    .onGet(
      userIdentityApiRoutes.fullIdentitySaveKeysStatus.replace(
        '{processId}',
        'processId'
      )
    )
    .reply(200, {
      uuid: 'user-uuid',
      status: 'SAVE_KEYS_FINISHED'
    });

  mock
    .onGet(
      userIdentityApiRoutes.fullIdentitySaveKeysStatus.replace(
        '{processId}',
        'processId'
      )
    )
    .reply(200, {
      uuid: 'user-uuid',
      status: 'SAVE_KEYS_FINISHED'
    });

  mock
    .onPost(userIdentityApiRoutes.fullIdentityTwoFactorAuthorizationSend)
    .reply(200, {
      processId: 'test-id',
      status: 'OK'
    });

  mock
    .onPost(userIdentityApiRoutes.fullIdentityTwoFactorAuthorizationCheck)
    .reply((config: AxiosRequestConfig) => {
      const { confirmationCode } = JSON.parse(config.data);

      if (confirmationCode === 'invalid') {
        return [
          400,
          {
            statusCode: 'INVALID_CODE'
          }
        ];
      }
      return [
        200,
        {
          status: 'OK',
          uuid: 'test-id'
        }
      ];
    });

  mock
    .onPost(userIdentityApiRoutes.fullIdentityTwoFactorAuthorizationResend)
    .reply(200, {
      status: 'OK'
    });

  mock.onPost(documentApiRoutes.agreementAccept).reply(200, {
    status: 'PUBLISHING-OK',
    signingStatus: AgreementStatusEnum.ACCEPTED_WAITING_FOR_PUBLISHING
  });

  mock.onPost(documentApiRoutes.agreementReject).reply(200, {
    status: 'PUBLISHING-OK',
    signingStatus: AgreementStatusEnum.REJECTED_WAITING_FOR_PUBLISHING
  });

  mock.onGet(documentApiRoutes.settings).reply(200, {
    SUPPORT_EMAIL: 'support@example.com',
    DESCRIPTION: '',
    PUBLICATOR_NAME: 'Billon',
    CUSTOM_LOGO: 'data:image/png;base64,iVBORw0KGgoAAA==',
    VERIFY_CHECKSUM: true,
    MAX_SIZE_VERIFY_FILE: '10 MB'
  });

  mock.onGet(documentApiRoutes.partnerEncryptionKey).reply(200, {
    status: 'PUBLISHING-OK',
    keyInfo: {
      keyData:
        'MGowFAYHKoZIzj0CAQYJKyQDAwIIAQEJA1IABLduaoKEoxsobUeKJpRgu9/iPGOtjfm/0DZzftOBUo0/aCGKNPWlNuegNLdlK5XAO4rC/iw/Q8mOciWdn8WzFMaFDAxjBD+XoA/DGA/ppPt6',
      keyValidityPeriod: 'SIX-YEARS',
      keyName: 'ECIES'
    }
  });
};
